import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Chat = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="chat icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0018 0.959961C5.37346 0.959961 0 5.4376 0 10.9613C0 14.5422 2.26019 17.6824 5.65478 19.449C5.25104 20.5546 4.55398 21.3708 3.65288 22.1033C3.48485 22.2407 3.45605 22.4888 3.55158 22.6838C3.63704 22.8566 3.81178 22.9632 4.00045 22.9632C5.95099 22.9632 8.08251 22.0371 9.83046 20.7961C10.5347 20.9036 11.2596 20.9627 12.0018 20.9627C18.6302 20.9627 24.0037 16.4846 24.0037 10.9613C24.0037 5.4376 18.6302 0.959961 12.0018 0.959961Z"
    />
  </svg>
)
